import React, { useState } from "react";
import axios from "axios";
import getAPI from "../../service/getAPI";

function Changepassword({ user }) {
  const { master } = getAPI();
  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
    setErrorMsg("");
    setSuccessMsg("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setSuccessMsg("");

    if (!formData.currentPassword) {
      setErrorMsg("Please enter your current password.");
      return;
    }

    if (!formData.newPassword) {
      setErrorMsg("Please enter a new password.");
      return;
    }

    if (formData.newPassword.length < 4) {
      setErrorMsg("New password must be at least 4 characters.");
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      setErrorMsg("New password and confirm password do not match.");
      return;
    }

    if (formData.currentPassword === formData.newPassword) {
      setErrorMsg("New password cannot be the same as current password.");
      return;
    }

    try {
      setLoading(true);
      const storeId = user?.store_id || localStorage.getItem("store_id");
      const res = await axios.post(master.storeChangePassword, {
        store_id: storeId,
        currentPassword: formData.currentPassword,
        newPassword: formData.newPassword,
      });

      if (res.data.flag === 1) {
        setSuccessMsg(res.data.message || "Password changed successfully!");
        setFormData({
          currentPassword: "",
          newPassword: "",
          confirmPassword: "",
        });
      } else {
        setErrorMsg(res.data.message || "Failed to update password. Please check your current password.");
      }
    } catch (err) {
      console.error("Change password error:", err);
      setErrorMsg(err.response?.data?.message || "An error occurred while updating your password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tab-pane fade show active profile-change-password pt-3" id="profile-change-password">
      <h5 className="card-title fw-bold mb-4">Change Branch Password</h5>

      {successMsg && (
        <div className="alert alert-success d-flex align-items-center mb-4" role="alert">
          <i className="bi bi-check-circle-fill me-2 fs-5"></i>
          <div>{successMsg}</div>
        </div>
      )}

      {errorMsg && (
        <div className="alert alert-danger d-flex align-items-center mb-4" role="alert">
          <i className="bi bi-exclamation-triangle-fill me-2 fs-5"></i>
          <div>{errorMsg}</div>
        </div>
      )}

      <form onSubmit={handleSubmit} style={{ maxWidth: "600px" }}>
        {/* Current Password */}
        <div className="row mb-3">
          <label htmlFor="currentPassword" className="col-md-4 col-form-label fw-semibold text-muted">
            Current Password <span className="text-danger">*</span>
          </label>
          <div className="col-md-8">
            <div className="input-group">
              <input
                name="currentPassword"
                type={showCurrent ? "text" : "password"}
                className="form-control"
                id="currentPassword"
                placeholder="Enter current password"
                value={formData.currentPassword}
                onChange={handleChange}
                required
              />
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => setShowCurrent(!showCurrent)}
                tabIndex="-1"
              >
                <i className={`bi bi-eye${showCurrent ? "-slash" : ""}`}></i>
              </button>
            </div>
          </div>
        </div>

        {/* New Password */}
        <div className="row mb-3">
          <label htmlFor="newPassword" className="col-md-4 col-form-label fw-semibold text-muted">
            New Password <span className="text-danger">*</span>
          </label>
          <div className="col-md-8">
            <div className="input-group">
              <input
                name="newPassword"
                type={showNew ? "text" : "password"}
                className="form-control"
                id="newPassword"
                placeholder="Enter new password (min 4 chars)"
                value={formData.newPassword}
                onChange={handleChange}
                required
              />
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => setShowNew(!showNew)}
                tabIndex="-1"
              >
                <i className={`bi bi-eye${showNew ? "-slash" : ""}`}></i>
              </button>
            </div>
          </div>
        </div>

        {/* Confirm New Password */}
        <div className="row mb-4">
          <label htmlFor="confirmPassword" className="col-md-4 col-form-label fw-semibold text-muted">
            Confirm Password <span className="text-danger">*</span>
          </label>
          <div className="col-md-8">
            <div className="input-group">
              <input
                name="confirmPassword"
                type={showConfirm ? "text" : "password"}
                className="form-control"
                id="confirmPassword"
                placeholder="Re-enter new password"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
              />
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => setShowConfirm(!showConfirm)}
                tabIndex="-1"
              >
                <i className={`bi bi-eye${showConfirm ? "-slash" : ""}`}></i>
              </button>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-8 offset-md-4">
            <button type="submit" className="btn btn-primary fw-bold px-4" disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Updating...
                </>
              ) : (
                <>
                  <i className="bi bi-key me-2"></i>Update Password
                </>
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default Changepassword;
